import React from 'react';
import FraudHitEvaluatorStatusChangeItem from '../../../Domain/FraudHitEvaluatorStatusChangeItem';
import AntiFraudToolService from '../../../Services/AntiFraudToolService';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import selectHelper from '../../../Helpers/selectHelper';
import FraudHitEvaluatorTab from './FraudHitEvaluatorTab';

export default class FraudHitEvaluatorFraudStatusChangeWindowDescription extends React.Component {
  static titleForCreate = 'Fraud Status Change';
  static titleForEdit = 'Fraud Status Change';
  static itemType = FraudHitEvaluatorStatusChangeItem;
  static serviceFunction = (edited) => AntiFraudToolService.ChangeFraudStatus(edited);
  static messageOnSuccess = (edited) => {
    let ids = edited.EvaluatorIds;

    if (Array.isArray(ids)) {
      if (ids.length > 10) {
        const firstFive = ids.slice(0, 5).join(', ');
        return `The fraud status of these Shoppers are updated: ${firstFive}, and more...`;
      }
      return `The fraud status of these Shoppers are updated: ${ids.join(', ')}`;
    }

    return `The fraud status of these Shoppers are updated: ${edited.EvaluatorIds}`;
  };

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'FraudStatus',
          label: 'Fraud Status',
          className: 'col-12',
          type: InputTypesEnum.Select,
          EntityId: 'FraudHitEvaluatorId',
          validityChecker: ValidityHelper.AlwaysFlawless,
          selectvalues: FraudHitEvaluatorFraudStatusChangeWindowDescription.getFraudStatuses(),
        },
        {
          fieldName: 'PendingOnId',
          label: 'Pending On *',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) => !item.IsNewlyDetected,
          // roleKey: "evaluatorpayment_editassignee",
        },
        {
          fieldName: 'SendDeactivationEmail',
          label: 'Send Deactivation Email?',
          className: 'col-12',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => item.FraudStatus !== 'Confirmed Fraud',
          // roleKey: "evaluatorpayment_editassignee",
        },
        {
          fieldName: 'DeactivationEmailRecipients',
          label: 'Deactivation Email Recipients',
          className: 'col-12',
          type: InputTypesEnum.Text,
          EntityId: 'DeactivationEmailRecipients',
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !item.SendDeactivationEmail,
        },
        {
          fieldName: 'DeactivationEmailSubject',
          label: 'Deactivation Email Subject',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
          EntityId: 'DeactivationEmailSubject',
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !item.SendDeactivationEmail,
        },
        {
          fieldName: 'DeactivationEmailBody',
          label: 'Deactivation Email Body',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          EntityId: 'DeactivationEmailBody',
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => !item.SendDeactivationEmail,
        },
      ],
    },
  ];

  static getFraudStatuses() {
    return selectHelper.generateSelectValues([
      'Under Investigation',
      'Confirmed Fraud',
      'Cleared',
      'Confirmed & Deactivated',
    ]);
  }
}
